import React, { useEffect, useRef, useState } from "react";
import { Navigate } from "react-router-dom";
import image from "../assets/img/404/vector404.svg";
import search from "../assets/img/icons/search-normal.svg";
import useFetch from "../hooks/useAxios";
const NotFoundPage = () => {
    const [searchResult, setsearchResult] = useState();
    const [searchvalue, setsearchvalue] = useState(null);
    const [isResults, setisResults] = useState(false)
    const apiSearch = useFetch({
      method: "get",
      url: `api/residences/search`,
      noHeader: true,
      trigger: false,
      params: { q: searchvalue },
      argFunc: res => {
        setsearchResult(res.data);
        setisResults(true)
      }
    });
  
  
    const Searchparams = e => {
      if (e.target.value.length >= 3) {
        setsearchvalue(e.target.value);
      }else
      if(e.target.value.length===0){
        setsearchvalue(null)
        setsearchResult()
        setisResults(false)
      }
    };
    useEffect(
      () => {
        if (searchvalue !== null ) {
          apiSearch.reFetch();
        }
       
      },
      [searchvalue]
    );
  const ref = useRef(null)
console.log(isResults)
  return (
    <div className="container">
      <div className="center-column NotFoundPage">
        <img src={image} className="NotFoundPage--img" />
        <h3>صفحه مورد نظر در دسترس نمی‌باشد</h3>
        <p>
          متاسفانه خطایی هنگام انتقال درخواست شما رخ داده است برای پیدا کردن
          مسیر درست میتوانید به صفحه ی اصلی وبسایت جاتیک مراجعه نمایید .
        </p>
       <div ref={ref} className={`NotFoundPage__searching ${isResults ? "NotFoundPage__searching--open":"NotFoundPage__searching--close"}`}
       
       style={isResults ? {
        maxHeight:`calc(${85 + ref.current.clientHeight}px)`
        }:{maxHeight:"85px"}}
       >
       <div className="NotFoundPage__searchbox relative">
        <input placeholder="اقامتگاه مورد نظر خود را جست و جو کنید ..."  onChange={e => Searchparams(e)}/>

        <button>
          <img src={search} />
        </button>
       
      </div>

       { isResults && <div className="NotFoundPage-searchresult">
          {searchResult?.length > 0
            ? searchResult.map(i =>
             
                  <div
                    onClick={() => {
                      Navigate(`/place/${i.code}/${i.slug}`);
                      setsearchResult();
                    }}
                    className="dropbox-search--div cursor-pointer"
                    key={i.code}
                  >
                    {i.title}
                  </div>
             
              )
            : <div  className="dropbox-search--div cursor-pointer">اقامتگاهی با این مشخصات یافت نشد</div>}
        </div>}
       </div>
      </div>
     
    </div>
  );
};

export default NotFoundPage;
